// src/pages/admin/integrations/shopify/components/ShopifyHeader.tsx
import type { FC } from 'react';
import { SiShopify } from 'react-icons/si';
import { ShopifyInfo } from '../../../types/integrations';
import { STATUS } from '../../../util/Constants';
import StatusPill from '../../../components/common/StatusPillAndCopyRow';
import { formatDate } from '../../../util/functions/UniversalFunctions';

interface Props {
  info: ShopifyInfo | null;
  onDisconnect?: () => void;
}

const ShopifyHeader: FC<Props> = ({ info, onDisconnect }) => {
  const s = info ? STATUS[info.status] : STATUS.NOT_CONNECTED;
  const showDisconnect = !!info && info.status !== 'NOT_CONNECTED';

  return (
    <header className="flex items-start gap-4 mb-6">
      <span
        className="inline-flex items-center justify-center rounded-lg shrink-0"
        style={{ width: 48, height: 48, background: '#5e8e3e' }}
      >
        <SiShopify className="text-2xl text-white" />
      </span>

      <div className="flex-1 min-w-0">
        <h1 className="text-xl font-bold text-slate-900">Shopify</h1>
        <div className="flex items-center gap-2 flex-wrap mt-1">
          <StatusPill kind={s.cls}>{s.label}</StatusPill>
          {info?.account && (
            <span className="text-xs text-slate-500">{info.account}</span>
          )}
          {info?.lastEventAt && (
            <span className="text-xs text-slate-500">
              Last event {formatDate(info.lastEventAt)}
            </span>
          )}
        </div>
      </div>

      {showDisconnect && (
        <button
          type="button"
          onClick={onDisconnect}
          className="px-3 py-1.5 text-sm rounded-lg border border-red-300 text-red-600 hover:bg-red-50"
        >
          Disconnect
        </button>
      )}
    </header>
  );
};

export default ShopifyHeader;